@for (hint of hints; track hint) {
  <cs-note x-small>{{ hint() }}</cs-note>
}
